export default __webpack_public_path__ + "static/media/toledo_9.092ff181.png";